module.exports = __webpack_public_path__ + "img/logo.612d5fab.png";